import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getMainWorkStatusCount } from '../../../api/dashboard';
import { contractSearchParams, counselSearchParams } from '../../../constants/adeleSearchParams';
import { contractListUrl, counselListUrl } from '../../../constants/adeleUrl';
import { queryKey } from '../../../constants/queryKey';
import { useSubsidiary } from '../../../context/SubsidiaryContext';
import { useUser } from '../../../context/UserContext';
import SysConfigStore from '../../../store/common/SysConfigStore';
import { navigateToAdele } from '../../../util/commonUtils';
import StatusCardDashboard from './StatusCardDashboard';

export default function StatusDashboardDefault() {
	const { id: subsidiaryId } = useSubsidiary();
	const { data: statusCount } = useQuery([queryKey.dashboard, queryKey.workStatusCount, subsidiaryId], () =>
		getMainWorkStatusCount(subsidiaryId),
	);
	const { t } = useTranslation();
	const { isModuleEnabled, isComponentEnabled, labelText } = SysConfigStore();
	const { isViewer } = useUser();

	const handleNavigate = (
		url: string,
		workType: 'CONTRACT' | 'COUNSEL' | 'CONTRACT_ETC',
		status: 'REVIEW' | 'COMPLETE',
	) => {
		const paramsMap = {
			CONTRACT: contractSearchParams,
			COUNSEL: counselSearchParams,
			CONTRACT_ETC: contractSearchParams,
		};

		if (['CONTRACT', 'CONTRACT_ETC'].includes(workType)) {
			sessionStorage.setItem('/contract/get-list-view-v28/', JSON.stringify({ contract_type: workType }));
		}
		if (workType === 'CONTRACT_ETC') workType = 'CONTRACT';
		sessionStorage.setItem(
			`${workType.toLowerCase()}_search_param`,
			JSON.stringify({
				...paramsMap[workType],
				status_check: `PROGRESS_STS_${status}`,
			}),
		);

		navigateToAdele(url);
	};

	const reviewItems = [
		{
			count: statusCount?.contract.review_count,
			label: '계약',
			onClick: () => handleNavigate(contractListUrl, 'CONTRACT', 'REVIEW'),
		},
		{
			count: statusCount?.counsel.review_count,
			label: '자문',
			onClick: () => handleNavigate(counselListUrl, 'COUNSEL', 'REVIEW'),
		},
		{
			count: statusCount?.contract_etc?.review_count,
			label: t('label_etc_contract').replace('{{계약외문서}}', labelText('etc_contract')),
			onClick: () => handleNavigate(contractListUrl, 'CONTRACT_ETC', 'REVIEW'),
			display: isComponentEnabled('CMPNT165_CONTRACT_ETC_BF'),
		},
	];

	const completedItems = [
		{
			count: statusCount?.contract.completed_count,
			label: '계약',
			onClick: () => handleNavigate(contractListUrl, 'CONTRACT', 'COMPLETE'),
		},
		{
			count: statusCount?.counsel.completed_count,
			label: '자문',
			onClick: () => handleNavigate(counselListUrl, 'COUNSEL', 'COMPLETE'),
		},
		{
			count: statusCount?.contract_etc?.completed_count,
			label: t('label_etc_contract').replace('{{계약외문서}}', labelText('etc_contract')),
			onClick: () => handleNavigate(contractListUrl, 'CONTRACT_ETC', 'COMPLETE'),
			display: isComponentEnabled('CMPNT165_CONTRACT_ETC_BF'),
		},
	];

	if (isModuleEnabled('VIEWER_HIDE_COUNSEL') && isViewer) {
		reviewItems.splice(1, 1);
		completedItems.splice(1, 1);
	}

	return (
		<>
			<StatusCardDashboard title='검토중인 법무' items={reviewItems} />
			<StatusCardDashboard title='완료된 법무' items={completedItems} />
		</>
	);
}
